<template lang="pug">
  v-dialog.d-inline(v-model="isModalVisible" max-width="580")
    v-card
      title-bar(dark) Share This Folder And Templates
      v-card-text.pb-0.members-card
        span This folder and its templates will be copied over to the team member you select:
        v-text-field.pb-2(
          label="Search team member"
          hide-details
          v-model="searchField"
          prepend-inner-icon="search"
        )
        div.scroll-card.pt-3
        div(v-if="noTeamMembersToShare")
          span No team members to share with
        v-list.px-3.scroll-card
          v-checkbox.ma-0.black--text.pa-0(
            v-for="member in filteredTeamMembers"
            v-model="selectedTeamMembers"
            :label="`${ member.user.first_name || '' } ${ member.user.last_name || '' }`"
            :value="member.user"
            :key="member.user.id"
          )
      v-card-actions.pa-3
        v-spacer
        v-btn(flat @click="closeModal") Cancel
        v-btn.primary(@click="save" :disabled="!hasTeamMemberSelected" data-cy="add-event") Share
</template>
<script>
import Modal from '@/Core/mixins/modal';
import TitleBar from '@/Core/components/TitleBar';
import { mapState } from 'vuex';

export default {
  components: {
    TitleBar
  },
  mixins: [Modal],
  props: {
    teamMembers: Array,
  },
  data() {
    return {
      selectedTeamMembers: [],
      searchField: '',
      folder: {},
    };
  },
  computed: {
    ...mapState({
      currentUser: state => state.userInformation.user,
    }),
    filteredTeamMembers() {
      if(this.currentUser) {
        return this.filterRepeatedTeamMembers(this.teamMembers).filter(member => {
          const { first_name, last_name } = member.user;
          return first_name.toUpperCase().includes(this.searchField.toUpperCase())
          || last_name.toUpperCase().includes(this.searchField.toUpperCase());
        });
      }
    },
    noTeamMembersToShare() {
      return !this.filteredTeamMembers || !this.filteredTeamMembers.length;
    },
    hasTeamMemberSelected() {
      return this.selectedTeamMembers.length > 0;
    },
  },
  methods: {
    save() {
      if (this.hasTeamMemberSelected) {
        const teamMembersIds = this.selectedTeamMembers.map(member => member.id);
        this.$emit('share-folder', this.folder.id, teamMembersIds);
        this.closeModal();
      }
    },
    open_modal(folder) {
      this.folder = folder;
      this.modal_open();
    },
    closeModal() {
      this.searchField = '';
      this.selectedTeamMembers = [];
      this.modal_close();
    },
    canShareFolderToMember(teamMemberId) {
      return this.teamMembers.some(member => {
        if(this.currentUser.id !== teamMemberId && member.user.id === teamMemberId) {
          return this.currentUser.id === member.team.owner_user || member.team.share_on 
        }
      });
    },
    /**
     * this method will return an array with the team members objects
     * that the current user can share a folder with
     * without any duplicated team member
     */
    filterRepeatedTeamMembers(teamMembersInfo) {
      const uniqueTeamMembers = new Set();
      return teamMembersInfo.filter(member => {
        if(uniqueTeamMembers.has(member.user.id)) return false;
        uniqueTeamMembers.add(member.user.id);
        return this.canShareFolderToMember(member.user.id);
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.members-card {
  max-height: 460px;
}
</style>
